import { Lang } from 'Roblox';
import angular from 'angular';

const groupPayouts = angular
  .module('groupPayouts', [
    'robloxApp',
    'groupPayoutsTemplates',
    'thumbnails',
    'groups',
    'ui.bootstrap'
  ])
  .config([
    'languageResourceProvider',
    function (languageResourceProvider) {
      // Temporary until translations added
      const resource = Lang.GroupsResources;
      const translationConstants = {
        // Transactions List
        'Label.AddFunds': (resource && resource['Label.AddFunds']) || 'Add Funds',
        'Label.AddFundsAmount': (resource && resource['Label.AddFundsAmount']) || 'Amount',
        'Action.Transfer': (resource && resource['Action.Transfer']) || 'Transfer',
        'Label.LastAddedFunds':
          (resource && resource['Label.LastAddedFunds']) ||
          'Successful transfer from {userName} to {groupName} on {transferDate}.',
        'Label.AddFundsPrompt':
          (resource && resource['Label.AddFundsPrompt']) ||
          'Transfer from {userName} to {groupName}',
        'Message.AddFundsLimitMessage':
          (resource && resource['Message.AddFundsLimitMessage']) ||
          'Transfers subject to holds. You can only transfer robux to this group from your account once every {limit} days',
        'Heading.AddFundsModal':
          (resource && resource['Heading.AddFundsModal']) || 'Transfer Funds',
        'Message.AddFundsModal':
          (resource && resource['Message.AddFundsModal']) ||
          'Are you sure you want to transfer {robuxWithIcon} to {groupName}?',
        'Label.IndividualToGroupTotal':
          (resource && resource['Label.IndividualToGroupTotal']) ||
          'Individual to Group Robux Transfers (includes pending transfers)',
        'Message.InsufficentFunds':
          (resource && resource['Message.InsufficentFunds']) || 'Insufficent Robux Funds',
        'Message.MaximumExceeded':
          (resource && resource['Message.MaximumExceeded']) ||
          'The maximum amount of Robux eligible to be transferred is {robux}',
        'Message.GeneralAddFundsError':
          (resource && resource['Message.GeneralAddFundsError']) || 'Something Went Wrong',
        'Message.UserGroupPayoutIneligible':
          (resource && resource['Message.UserGroupPayoutIneligible']) ||
          'User is new to group and not yet eligible for payouts. Please try again later.',
        'Heading.TwoStepVerificationRequired':
          (resource && resource['Heading.TwoStepVerificationRequired']) || 'Verification Required',
        'Message.TwoStepVerificationRequiredv2':
          (resource && resource['Message.TwoStepVerificationRequiredv2']) ||
          '2-Step Verification is required to make further transactions. Go to your Security page to enable and complete 2-Step Verification.',
        'Action.GoToSecurity': (resource && resource['Action.GoToSecurity']) || 'Go to Security',
        'Label.AddPayoutRecipients':
          (resource && resource['Label.AddPayoutRecipients']) || 'Add Payout Recipients'
      };

      if (Lang.GroupsResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.GroupsResources);
        languageResourceProvider.setLanguageKeysFromFile(translationConstants);
      }
      if (Lang.TwoStepVerificationResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.TwoStepVerificationResources);
      }
    }
  ]);

export default groupPayouts;
